<ng-container *transloco="let t">
  <ld-base-modal
    id="tour-welcome-modal"
    [title]="t('tourWelcomeTitle')"
    [showCloseButton]="false"
    [closeOnBackdropClick]="false"
    [isLoading]="isLoading()"
    size="large"
    ariaLabelledBy="tour-welcome-modal-title"
  >
    <div modal-content class="flex flex-col items-center gap-6">
      <div class="flex items-center justify-center w-[104px] h-[104px]">
        <img [src]="tourPortalIcon" alt="" aria-hidden="true" class="w-[104px] h-[104px]" />
      </div>

      <p
        id="tour-welcome-modal-description"
        class="text-ld-neutral-600 leading-relaxed text-center font-dm text-base font-medium"
      >
        {{ t('tourWelcomeDescription') }}
      </p>
    </div>

    <div modal-footer class="flex flex-wrap items-center justify-center gap-6">
      <button
        id="tour-welcome-skip-tour-btn"
        type="button"
        class="btn-outline-ld-purple px-5 py-2 uppercase rounded-[20px] text-base font-bold font-dm tracking-[0.5px] disabled:opacity-50 disabled:cursor-not-allowed"
        [disabled]="isLoading() || loadingAction()"
        (click)="onSkipTour()"
      >
        @if (loadingAction() === 'skip_tour') {
          <mat-spinner diameter="20" class="w-5! h-5! [&_circle]:stroke-ld-primary!"></mat-spinner>
        }
        {{ t('tourWelcomeSkipTour') }}
      </button>

      <button
        id="tour-welcome-remind-later-btn"
        type="button"
        class="btn-outline-ld-purple px-5 py-2 uppercase rounded-[20px] text-base font-bold font-dm tracking-[0.5px] disabled:opacity-50 disabled:cursor-not-allowed"
        [disabled]="isLoading() || loadingAction()"
        (click)="onRemindLater()"
      >
        {{ t('tourWelcomeRemindLater') }}
      </button>

      <button
        id="tour-welcome-take-tour-btn"
        type="button"
        class="btn-primary-ld-purple px-5 py-2 uppercase rounded-[20px] text-base font-bold font-dm tracking-[0.5px] disabled:opacity-50 disabled:cursor-not-allowed"
        [disabled]="isLoading() || loadingAction()"
        (click)="onTakeTour()"
      >
        @if (loadingAction() === 'take_tour') {
          <mat-spinner diameter="20" class="w-5! h-5! [&_circle]:stroke-white!"></mat-spinner>
        }
        {{ t('tourWelcomeTakeTour') }}
      </button>
    </div>
  </ld-base-modal>
</ng-container>
